import { render, staticRenderFns } from "./RmWasteSendBackToStockPopUp.vue?vue&type=template&id=540f56bc&scoped=true&"
import script from "./RmWasteSendBackToStockPopUp.vue?vue&type=script&lang=js&"
export * from "./RmWasteSendBackToStockPopUp.vue?vue&type=script&lang=js&"
import style0 from "./RmWasteSendBackToStockPopUp.vue?vue&type=style&index=0&id=540f56bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540f56bc",
  null
  
)

export default component.exports